<template>
  <div class="seek">
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="list.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="xs-list" v-if="loading || list.length > 0">
        <ZxItem
          class="xs-list-item"
          v-for="item in list"
          :key="item.articleId"
          :title="item.title"
          :img="item.cover"
          :creatTime="item.originalPublishTime"
          :number="item.pageViews"
          :author="item.periodical"
          @click.native="toDetails(item.articleId, item.articleType)"
        />
      </div>
      <noneList noneType="collect" v-else />
    </van-list>
  </div>
</template>

<script>
import { Toast } from "vant";
import ZxItem from "@/views/mobileView/components/listItem/zxItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "seek",
  components: {
    ZxItem,
    noneList,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      list: [],
    };
  },
  methods: {
    // 咨询列表
    async getUserCollectInformationList(data) {
      this.loading = true;
      const resp = await this.$apis.userServe.getUserCollectInformationList(
        data
      );
      if (resp.resultCode == 200) {
        this.list = resp.data.list;
        this.finished = resp.data.list.length < 20 ? true : false;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    onLoad() {
      if (sessionStorage.getItem("token")) {
        this.getUserCollectInformationList();
      } else {
        this.finished = true;
        Toast("请先登录");
      }
    },
    toDetails(id, type) {
      this.$router.push({
        name: "msgDetails",
        query: {
          id,
          type,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.seek {
  width: 94%;
  margin: 0 auto;
  height: 100%;
  background: #f5f5f5;
  .xs-list {
    margin: 12px auto 0;
    width: 351px;
    padding: 0 13px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .xs-list-item {
      border-bottom: 1px solid #eee;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>